import { environment } from '~app/environment';

import {
  webRequestClient,
  type RequestParams,
  type ScpClient,
} from '~shared/scp-client';

export type UserInfoResponse = {
  analyticsPersonId: string;
  personId: string;
  phoneNumber: string;
  sub: string;
};

export class GatewayUserInfoApi {
  private client: ScpClient;
  private host: string;

  constructor(client: ScpClient, host: string) {
    this.client = client;
    this.host = host;
  }

  async getUserInfo(): Promise<UserInfoResponse> {
    return this.makeRequest<UserInfoResponse>({
      method: 'userinfo',
    }).then((response) => response.payload);
  }

  private makeRequest<T = unknown>(
    params: Partial<RequestParams> & { method: string }
  ) {
    return this.client.call<T>({
      host: this.host,
      version: 'v1',
      domain: 'auth',
      service: 'authorizer/users',
      withCredentials: true,
      ...params,
    });
  }
}

export const gatewayUserInfoApi = new GatewayUserInfoApi(
  webRequestClient,
  environment.API_HOST
);
